import type { Contact } from '../../../components/address-book/address-book-types';

export enum AddressBookAction {
  SetSavedContacts = 'addressBook/setSavedContacts',
}

export type AddressBookState = {
  savedContacts: Contact[];
};

export type AddressBookActions = {
  setSavedContacts: (contacts: Contact[] | null) => void;
};

export type AddressBookSlice = AddressBookState & AddressBookActions;
